const apiWorkflow = {
  'get-list': {
    method: 'post',
    url: '/ws-admincp/workflow/list'
  },
  find: {
    method: 'get',
    url: '/ws-admincp/workflow/find'
  },
  add: {
    method: 'post',
    url: '/ws-admincp/workflow'
  },
  delete: {
    method: 'delete',
    url: '/ws-admincp/workflow'
  },
  archive: {
    method: 'delete',
    url: '/ws-admincp/workflow/archive'
  },
  restore: {
    method: 'put',
    url: '/ws-admincp/workflow/restore'
  },
  edit: {
    method: 'put',
    url: '/ws-admincp/workflow/ID'
  },
  getByID: {
    method: 'get',
    url: '/ws-admincp/workflow/ID'
  }
}

export default {
  ...apiWorkflow
}
